import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.approval.template');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ElementRef, ViewChild } from '@angular/core';
import { ClassicEditor, createCKEditorConfig } from "src/libs/portal/season/ckeditor";
import $ from "jquery";

@Component({
    selector: 'wiz-portal-lpsysadmin-approval-template',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.approval.template/view.scss */
:host {
  display: block;
  height: 100%;
}

.ck-editor__editable {
  min-height: 200px;
}

:host ::ng-deep .ck-content .table {
  margin-left: 0 !important;
  margin-right: auto !important;
  text-align: left;
}
:host ::ng-deep .ck-content table {
  margin-left: 0 !important;
  margin-right: auto !important;
}`],
})
export class PortalLpsysadminApprovalTemplateComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @ViewChild('templateEditor')
    public editorElement: ElementRef;
    public editor: any;

    public loaded: boolean = false;
    public templates: any[] = [];
    public adminUsers: any[] = [];
    public editingItem: any = null;
    public isNew: boolean = false;
    public showPreview: boolean = false;
    public previewItem: any = null;

    public categories: any[] = [
        { key: 'internal', label: '내부' },
        { key: 'fund_invest', label: '조합/투자기업' },
        { key: 'finance', label: '자금' },
        { key: 'support', label: '지원사업' },
        { key: 'tips', label: 'TIPS' }
    ];

    public roleOptions: any[] = [
        { key: 'all', label: '전체' },
        { key: 'admin', label: '관리자 이상' },
        { key: 'super_admin', label: '총괄관리자만' }
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.loadUsers();
        await this.loadList();
    }

    public async loadUsers() {
        const { code, data } = await wiz.call("users");
        if (code == 200) {
            this.adminUsers = data.rows || [];
        }
    }

    public async loadList() {
        this.loaded = false;
        await this.service.render();
        const { code, data } = await wiz.call("list");
        if (code == 200) {
            this.templates = data.rows || [];
        }
        this.loaded = true;
        await this.service.render();
    }

    public async initEditor() {
        if (!this.editorElement) return;
        let element = this.editorElement.nativeElement;
        if ($(element).parent().find(".ck-content").length == 0) {
            let toolbar = 'heading | fontSize | bold italic strikethrough underline | fontColor fontBackgroundColor alignment | blockQuote | bulletedList numberedList | uploadImage insertTable link horizontalLine | specialCharacters'.split(' ');
            this.editor = await ClassicEditor.create(element, createCKEditorConfig({
                toolbar,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableProperties', 'tableCellProperties'],
                    defaultProperties: {
                        alignment: 'left',
                        borderStyle: 'solid',
                        borderColor: '#d4d4d8',
                        borderWidth: '1px'
                    },
                    tableCellProperties: {
                        defaultProperties: {
                            borderStyle: 'solid',
                            borderColor: '#d4d4d8',
                            borderWidth: '1px',
                            padding: '6px 12px'
                        }
                    }
                }
            }));
        }
        this.editor.data.set(this.editingItem.content_template || '');
    }

    public async destroyEditor() {
        if (this.editor) {
            try { this.editor.destroy(); } catch(e) {}
            this.editor = null;
        }
    }

    public getCategoryLabel(key: string): string {
        const cat = this.categories.find((c: any) => c.key === key);
        return cat ? cat.label : key || '-';
    }

    public getRoleLabel(key: string): string {
        const role = this.roleOptions.find((r: any) => r.key === key);
        return role ? role.label : '전체';
    }

    public getUserName(userId: string): string {
        const user = this.adminUsers.find((u: any) => u.id === userId);
        return user ? user.name : '-';
    }

    public getUserTitle(userId: string): string {
        const user = this.adminUsers.find((u: any) => u.id === userId);
        return user ? (user.title || '') : '';
    }

    public async startCreate() {
        this.editingItem = {
            id: '',
            title: '',
            type: 'internal',
            content_template: '',
            default_line: [],
            default_viewers: [],
            allowed_roles: 'all',
            status: 'active'
        };
        this.isNew = true;
        await this.service.render();
        await this.initEditor();
    }

    public async startEdit(item: any) {
        let defaultLine = item.default_line;
        if (typeof defaultLine === 'string') {
            try { defaultLine = JSON.parse(defaultLine); } catch (e) { defaultLine = []; }
        }
        if (!defaultLine) defaultLine = [];

        let defaultViewers = item.default_viewers;
        if (typeof defaultViewers === 'string') {
            try { defaultViewers = JSON.parse(defaultViewers); } catch (e) { defaultViewers = []; }
        }
        if (!defaultViewers) defaultViewers = [];

        this.editingItem = {
            ...item,
            default_line: defaultLine.map((l: any) => ({ ...l })),
            default_viewers: defaultViewers.map((v: any) => ({ ...v })),
            allowed_roles: item.allowed_roles || 'all'
        };
        this.isNew = false;
        await this.service.render();
        await this.initEditor();
    }

    public async cancelEdit() {
        await this.destroyEditor();
        this.editingItem = null;
        this.isNew = false;
        await this.service.render();
    }

    public addDefaultLine() {
        if (!this.editingItem.default_line) this.editingItem.default_line = [];
        this.editingItem.default_line.push({ approver_id: '', order: this.editingItem.default_line.length + 1 });
        this.service.render();
    }

    public removeDefaultLine(index: number) {
        this.editingItem.default_line.splice(index, 1);
        this.editingItem.default_line.forEach((l: any, i: number) => l.order = i + 1);
        this.service.render();
    }

    public addDefaultViewer() {
        if (!this.editingItem.default_viewers) this.editingItem.default_viewers = [];
        this.editingItem.default_viewers.push({ approver_id: '', order: this.editingItem.default_viewers.length + 1 });
        this.service.render();
    }

    public removeDefaultViewer(index: number) {
        this.editingItem.default_viewers.splice(index, 1);
        this.editingItem.default_viewers.forEach((v: any, i: number) => v.order = i + 1);
        this.service.render();
    }

    public async openPreview(item?: any) {
        if (item) {
            this.previewItem = { ...item };
        } else if (this.editingItem) {
            if (this.editor) {
                this.editingItem.content_template = this.editor.data.get();
            }
            this.previewItem = { ...this.editingItem };
        }
        this.showPreview = true;
        await this.service.render();
    }

    public async closePreview() {
        this.showPreview = false;
        this.previewItem = null;
        await this.service.render();
    }

    public async save() {
        if (!this.editingItem.title.trim()) {
            this.service.alert.error("서식 제목을 입력해주세요.");
            return;
        }
        if (this.editor) {
            this.editingItem.content_template = this.editor.data.get();
        }
        await this.destroyEditor();
        const data = { ...this.editingItem };
        data.default_line = JSON.stringify(data.default_line || []);
        data.default_viewers = JSON.stringify(data.default_viewers || []);
        const { code, data: res } = await wiz.call("save", data);
        if (code == 200) {
            this.service.alert.success("저장되었습니다.");
            this.editingItem = null;
            this.isNew = false;
            await this.loadList();
        } else {
            this.service.alert.error(res?.message || "저장 실패");
        }
    }

    public async deleteTemplate(item: any) {
        const res = await this.service.alert.show({
            title: '서식 삭제',
            message: `'${item.title}' 서식을 삭제하시겠습니까?`,
            action: '삭제',
            actionBtn: 'error',
            status: 'error'
        });
        if (!res) return;
        const { code } = await wiz.call("delete", { id: item.id });
        if (code == 200) {
            this.service.alert.success("삭제되었습니다.");
            await this.loadList();
        }
    }

    public async toggleStatus(item: any) {
        const newStatus = item.status === 'active' ? 'inactive' : 'active';
        const { code } = await wiz.call("toggle_status", { id: item.id, status: newStatus });
        if (code == 200) {
            item.status = newStatus;
            await this.service.render();
        }
    }
}

export default PortalLpsysadminApprovalTemplateComponent;